import { Modal } from 'antd';
import classNames from 'classnames';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import NoDataFound from 'Components/common/components/NoDataFound';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { NODATAFOUND } from 'Utils/Constants';
import { PlusOutlined } from '@ant-design/icons';
import {
  maxMobile, primaryFont, primaryColor, secondaryFont, wLight,
  wMBold, wMedium,
  maxWidth, retina, maxWidth1300
} from 'Utils/utilsStyle';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCompaniesEnded,
  selectCompanyComparisonData, selectisComparisonLoading,
  selectisComparisonRemoved,
  selectRecommendedCompanies,
  selectRecommendedCompaniesLoading,
  selectCompanyDetailFlurry, selectCompanyDetailsCall, selectCompaniesExported,
  selectedCompareCompaniesIds,
} from 'Selector/CompaniesSelector';
import { Company } from 'Types/CompaniesTypes';
import { actions as helperActions, actions as flurryActions } from 'Slice/HelperSlice';
import AffinitySearchResultItemSkeleton from 'Components/common/skeleton/AffinitySearchResultItemSkeleton';
import { SearchResultsRequest } from 'Types/GlobalSearchResultsTypes';
import { actions as globalSearchActions } from 'Slice/GlobalSearchResultsSlice';
import { companiesData, selectLoading } from 'Selector/GlobalSearchResultsSelector';
import { useSearchParams } from 'react-router-dom';
import { IsMobile, getLangCookie, valueToObject } from 'Utils/UtilityFunctions';
import { usePrevious } from 'Utils/hooks/usePrevious';
import SmartCompanyListCard from 'Components/company/components/SmartCompanyListCard';
import { chatActions } from 'Components/layout/headers/NavBarPrimary';
import AddCompanyItem from './AddCompanyItem';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';

const Wrapper = styled.div`
.gilroy-mascot {
  position: absolute;
  top: 43px;
  right: 25px
}
.add-company-btn-compare {
  z-index: 1;
  position: relative;
  font-family: ${primaryFont};
  &:hover {
   outline: 2px solid #DADADA; 
  }
  &.disable {
    background-color: #bbedcb;
    pointer-events: none;
  }
}
.share-button-group {
  &.groupPageButton {
    height: 40px;
    padding: 8px 12px 8px 12px;
    border-radius: 8px;
    @media all and (max-width: ${maxMobile}) {
      padding: 10px 12px 2px 12px;
    }
    .icon-mode-text, .seperator {
      @media all and (max-width: ${maxMobile}) {
        display: none;
      }
    }
  }
  background-color: ${primaryColor};
  height: 30px;
  border-radius: 17px;
  padding: 7px 16px;
  font-family: ${secondaryFont};
  color: #fff;
  font-weight: ${wMBold};
  font-size: 14px;
  line-height: 17.09px;
  .icon-mode {
    display: inline-flex;
    align-content: center;
    column-gap: 8px;
    .icon-mode-text {
      font-weight: ${wLight};
      font-family: ${primaryFont};
      font-size: 14px;
    }
    .seperator {
      height: 18px;
      border-left: 1.5px solid #fff;
      margin: 0px 10px;
    }
    .share-icon {
      svg {
        height: 18px;
        width: 13px;
        min-width: 13px;
      }
    }
  }
}
`;

const Button = styled.span<{ stickyTableView: boolean }>`
  cursor: pointer;
  display: block;
  padding: 8px 20px 8px 15px;
  font-size: 16px;
  color: #fff;
  font-weight: ${wMedium};
  background-color: ${primaryColor};
  border-radius: 25px;
  line-height: 13px;
  width: 100%;
  display: inline-block;
  text-align: center;
  @media all and (max-width: ${maxWidth}),${retina} {
    font-size: 14px;
  }
  @media all and (max-width: ${maxWidth1300}) {
    font-size: 12px;
  }
  margin-top: ${(props) => (props.stickyTableView ? '10px' : '0px')};
  .anticon-plus {
    margin-right: 6px;
  } 
`;

type Props = {
  savedUrlV2?: string
  stickyTableView?: boolean
  smartAccountFlag?: boolean
  SAPCompany?: Company
  SAPCompanies?: Company[]
  SAPNoCompetitor?: boolean
  inCompanyCompare?: boolean
} & typeof defaultProps;

const defaultProps = {
  stickyTableView: false,
  smartAccountFlag: false,
  savedUrlV2: '',
  SAPCompany: {} as Company,
  SAPCompanies: [] as Company[],
  SAPNoCompetitor: false,
  inCompanyCompare: false,
};

const SelectCompanyModal = function SelectCompanyModal(props: Props) {
  const dispatch = useDispatch();
  const {
    stickyTableView, savedUrlV2, smartAccountFlag,
    SAPCompanies, SAPCompany, SAPNoCompetitor, inCompanyCompare,
  } = props;
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const [showPopup, setShowPopup] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearch, setIsSearch] = useState(false);
  const [searchPage, setSearchPage] = useState(1);
  const [showSelectedCompanyText, setshowSelectedCompanyText] = useState(true);
  const [selectedCompanies, setSelectedCompanies] = useState<Company[]>([]);
  const [companiesToDisplay, setCompaniesToDisplay] = useState<Company[]>([]);
  const [showCompetitors, setShowCompetitors] = useState<boolean>(false);
  const [selectedCompany, setSelectedCompany] = useState(SAPCompany);

  const recommendedCompanies: Company[] = useSelector(selectRecommendedCompanies);
  const recommendedLoading: boolean = useSelector(selectRecommendedCompaniesLoading);
  const searchedCompanies = useSelector(companiesData);
  const searchLoading = useSelector(selectLoading);
  const companyComparisonData = useSelector(selectCompanyComparisonData);
  const companiesEnded = useSelector(selectCompaniesEnded);
  const isComparisonLoading = useSelector(selectisComparisonLoading);
  const isComparisonRemoved = useSelector(selectisComparisonRemoved);
  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const companiesExported = useSelector(selectCompaniesExported);
  const prevCompanyCompData = usePrevious(companyComparisonData);
  const prevSelectedCompanies = usePrevious(selectedCompanies);
  const selectedCompareCompanies = useSelector(selectedCompareCompaniesIds);

  const isMob = IsMobile();
  const noFound = isSearch
    ? searchedCompanies.count === 0 : !recommendedCompanies.length && !SAPCompany.companyId;
  const matchingComapniesCount = searchedCompanies.companies?.filter((obj) => SAPCompanies
    ?.some((filterObj) => filterObj.companyId === obj.companyId)).length || 0;
  const modalToggle = () => {
    setShowPopup(!showPopup);
  };
  const modifiedCount = searchedCompanies.count - matchingComapniesCount;

  useEffect(() => {
    if (companiesExported) {
      setShowPopup(false);
    }
  }, [companiesExported]);

  useEffect(() => {
    if (!selectedCompareCompanies.length && inCompanyCompare) {
      if (!companyId) {
        modalToggle();
      }
    }
  }, [selectedCompareCompanies]);

  useEffect(() => {
    if (companyComparisonData.length) {
      setShowCompetitors(true);
    } else {
      setShowCompetitors(false);
    }
  }, [companyComparisonData]);

  useEffect(() => {
    if (showPopup) {
      selectedCompanies.push(...selectedCompanies, ...companyComparisonData as Company[]);
      const companyIds = companyComparisonData?.length && showCompetitors ? companyComparisonData.map((company) => company.companyId).join(',') : '';
      dispatch(companiesActions.getRecommendedCompanies({
        ...(companyIds && companyIds.length && { companyIds }),
        ...(smartAccountFlag && companyId
          && { companyIds: companyId }),
      }));
    } else {
      setSelectedCompanies([]);
      setSearchPage(1);
      setshowSelectedCompanyText(true);
    }
  }, [showPopup]);

  useEffect(() => {
    if (inCompanyCompare && !selectedCompareCompanies.length) {
      if (!companyId) {
        setShowPopup(true);
      }
    } else if (!inCompanyCompare) {
      if (companyComparisonData.length === 0 && prevCompanyCompData?.length !== 0
        && !isComparisonLoading
        && !companyId && !isComparisonRemoved && !savedUrlV2.length && !companiesExported) {
        setShowPopup(true);
      }
      if (savedUrlV2) {
        chatActions.setSaveUrl('');
        chatActions.setSaveProfileName('');
      }
    }
  }, [companyComparisonData]);

  useEffect(() => {
    if (isSearch && searchedCompanies) {
      setCompaniesToDisplay(smartAccountFlag && searchedCompanies?.companies?.length
        ? searchedCompanies?.companies?.filter((obj) => !SAPCompanies
          ?.some((filterObj) => filterObj.companyId === obj.companyId))
        : searchedCompanies?.companies as Company[]);
    } else if (!showCompetitors) {
      setCompaniesToDisplay(smartAccountFlag ? recommendedCompanies?.filter((obj) => !SAPCompanies
        ?.some((filterObj) => filterObj.companyId === obj.companyId))
        : recommendedCompanies);
    } else {
      setCompaniesToDisplay(smartAccountFlag ? recommendedCompanies?.filter((obj) => !SAPCompanies
        ?.some((filterObj) => filterObj.companyId === obj.companyId))
        : recommendedCompanies);
    }
  }, [searchedCompanies, isSearch, recommendedCompanies]);

  useEffect(() => {
    if (searchTerm === '') {
      setIsSearch(false);
    }
  }, [searchTerm]);

  const itemClickHandler = (company: Company) => {
    if (smartAccountFlag) {
      setSelectedCompany(company);
    } else if (selectedCompanies
      .findIndex(({ companyId: Id }) => Id === company.companyId) !== -1) {
      const remainingCompanies = [...selectedCompanies];
      remainingCompanies.splice(remainingCompanies.findIndex(
        ({ companyId: Id }) => Id === company.companyId,
      ), 1);
      setSelectedCompanies(remainingCompanies);
    } else {
      setSelectedCompanies((prev) => [...prev, company]);
    }
  };

  const fetchMore = () => {
    if (showSelectedCompanyText) {
      if (isSearch && !searchLoading) {
        const obj: SearchResultsRequest = {
          page: searchPage + 1,
          query: `company:${searchTerm}`,
          defaultLanguage: getLangCookie(),
          ...(smartAccountFlag && { inSap: true, companyId: parseInt(companyId || '', 10) }),
        };
        dispatch(globalSearchActions.globalSearchResults(obj));
        setSearchPage(searchPage + 1);
      }
    }
  };

  const onSearching = (searchText: string) => {
    setSearchPage(1);
    setshowSelectedCompanyText(true);
    setSearchTerm(searchText);
    if (searchText !== '') {
      const obj: SearchResultsRequest = {
        query: `company:${searchText}`,
        screenName: 'compareCompany',
        defaultLanguage: getLangCookie(),
        ...(smartAccountFlag && { inSap: true, companyId: parseInt(companyId || '', 10) }),
      };
      dispatch(globalSearchActions.globalSearchResults(obj));
      setIsSearch(true);
    }
  };

  const selectedCompanyHandler = () => {
    const searchResults = searchedCompanies?.companies as Company[];
    if (showSelectedCompanyText) {
      setCompaniesToDisplay(selectedCompanies);
    } else if (isSearch) setCompaniesToDisplay(searchResults);
    else if (!showCompetitors) setCompaniesToDisplay(recommendedCompanies);
    else setCompaniesToDisplay(recommendedCompanies);
    setshowSelectedCompanyText(!showSelectedCompanyText);
  };

  const handleCompareCompanies = () => {
    if (smartAccountFlag) {
      dispatch(companiesActions.updateSAPCompany(
        { prevCompany: SAPCompany?.companyId ? SAPCompany : null, newCompany: selectedCompany },
      ));
    } else {
      const data = {
        companyIds: selectedCompanies?.map((item) => item.companyId).join(','),
      };
      const compareData = {
        companyIds: selectedCompanies.slice(0, 4).map((item) => item.companyId).join(','),
      };
      selectedCompanies?.slice(0, 4)?.forEach((item) => {
        const companyId = item?.companyId;
        const alreadyExists = selectedCompareCompanies?.includes(companyId);
        if (!alreadyExists) {
          dispatch(companiesActions.selectedCompareCompaniesIds(item?.companyId));
        }
      });
      dispatch(companiesActions.compareCompanies(compareData));
      if (selectedCompanies?.length > 4) {
        dispatch(companiesActions.compareCompaniesExport(data));
      }
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('add_compare_company', 0, {
          ...flurryObject,
          ...isCalled && { isCalled },
          companyIds: data.companyIds,
        }),
      ));
    }

    modalToggle();
  };

  useEffect(() => {
    if (selectedCompanies?.length === 5 && prevSelectedCompanies?.length === 4) {
      dispatch(helperActions.setNotification({
        message: 'You have selected more than four companies. Comparison data will be provided in an Excel file.',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
    }
  }, [selectedCompanies]);

  return (
    <Wrapper className="select-company-modal">
      {smartAccountFlag ? (
        <span
          role="button"
          tabIndex={-1}
          onClick={modalToggle}
          onKeyPress={modalToggle}
          aria-label="button"
        >
          <SmartCompanyListCard
            company={SAPCompany}
            noCompetitor={SAPNoCompetitor}
          />
        </span>
      ) : (
        <Button
          stickyTableView={stickyTableView}
          role="button"
          tabIndex={0}
          onClick={modalToggle}
          onKeyPress={modalToggle}
          className={classNames('add-company-btn-compare text-truncate')}
        >
          <PlusOutlined />
          Add Companies
        </Button>
      )}
      {(showPopup) && (
        <Modal
          centered
          open={showPopup}
          onCancel={() => modalToggle()}
          width={(smartAccountFlag && isMob) ? 320 : 379}
          wrapClassName={classNames('share-group-with-people-popup', { responsiveSAP: smartAccountFlag && isMob })}
          closable
          getContainer={smartAccountFlag ? (() => document.querySelector('.drawer-account-plan .ant-drawer-body') || document.body) : document.body}
        >

          <span className="heading-popup">
            {!smartAccountFlag ? 'Add more companies' : ''}
            {smartAccountFlag && SAPCompany.companyId ? 'Replace the company' : ''}
            {smartAccountFlag && !SAPCompany.companyId ? 'Add a Company' : ''}
          </span>

          <div className="person-search-bar">
            <AlertsSearch
              placeholderText="Search for companies"
              query={searchTerm}
              loading={recommendedLoading}
              onSearching={onSearching}
              margin="0px"
              height="36px"
            />
          </div>
          <div className="d-flex justify-content-between">
            <span className="heading-popup second-heading-popup">
              {isSearch && showSelectedCompanyText && !smartAccountFlag && `Search Result (${searchedCompanies?.count})`}
              {isSearch && showSelectedCompanyText && smartAccountFlag && `Search Result (${modifiedCount})`}
              {!showSelectedCompanyText && `Selected Companies (${selectedCompanies.length})`}
              {!isSearch && showSelectedCompanyText && !smartAccountFlag ? `Compare with (${recommendedCompanies.length})` : ''}
              {smartAccountFlag && !isSearch ? `Companies (${companiesToDisplay.length})` : ''}

            </span>
            {(selectedCompanies?.length && showSelectedCompanyText)
              || (!showSelectedCompanyText)
              ? (
                <span
                  tabIndex={0}
                  className="heading-popup selected-people"
                  role="button"
                  onClick={selectedCompanyHandler}
                  onKeyPress={selectedCompanyHandler}
                >
                  {showSelectedCompanyText ? `Select (${selectedCompanies.length})` : 'Back'}
                </span>
              ) : null}
          </div>
          <div className="h-100 w-100" id="compare-company">
            <InfiniteScroll
              hasMore={!isSearch ? false : !companiesEnded}
              dataLength={companiesToDisplay?.length ?? 0}
              next={fetchMore}
              loader={false}
              className="share-group-dropdown"
              height="auto"
            >
              {smartAccountFlag && !isSearch && SAPCompany?.companyId ? (
                <AddCompanyItem
                  companyLogo={SAPCompany.companyLogo}
                  companyPersonality={SAPCompany.companyPersonality || []}
                  companyPulse={SAPCompany.companyPulse || []}
                  onClick={() => itemClickHandler(SAPCompany)}
                  isChecked={
                    selectedCompanies
                      .findIndex(({ companyId: Id }) => Id === SAPCompany.companyId) !== -1
                  }
                  isRadioChecked={SAPCompany.companyId === selectedCompany?.companyId}
                  companyId={SAPCompany.companyId}
                  companyName={SAPCompany.companyName}
                  companyWebsite={SAPCompany.companyWebsite}
                  selectedCount={selectedCompanies.length}
                  showRadioBtn={smartAccountFlag}
                />
              ) : null}
              {companiesToDisplay.map((company) => (
                <AddCompanyItem
                  companyLogo={company.companyLogo}
                  companyPersonality={company.companyPersonality || []}
                  companyPulse={company.companyPulse || []}
                  onClick={() => itemClickHandler(company)}
                  isChecked={
                    selectedCompanies
                      .findIndex(({ companyId: Id }) => Id === company.companyId) !== -1
                  }
                  isRadioChecked={company.companyId === selectedCompany?.companyId}
                  companyId={company.companyId}
                  companyName={company.companyName}
                  companyWebsite={company.companyWebsite}
                  selectedCount={selectedCompanies.length}
                  showRadioBtn={smartAccountFlag}
                />
              ))}
              {(searchLoading || recommendedLoading)
                && (
                  <>
                    {[1, 2, 3, 4].map(() => <AffinitySearchResultItemSkeleton />)}
                  </>
                )}
              {companiesToDisplay.length === 0 && !searchLoading && !recommendedLoading && noFound
                ? <div className="no_data_found"><NoDataFound title={NODATAFOUND} /></div>
                : null}
            </InfiniteScroll>
          </div>
          <div className={classNames('share-group-footer', { footerSAP: smartAccountFlag })}>
            <span
              tabIndex={0}
              role="button"
              className={classNames('share-group-button share-button', { disabled: smartAccountFlag ? !selectedCompany.companyId : selectedCompanies?.length === 0 })}
              onClick={() => handleCompareCompanies()}
              onKeyPress={() => handleCompareCompanies()}
            >
              {!smartAccountFlag ? 'Compare' : ''}
              {smartAccountFlag && SAPCompany.companyId ? 'Replace' : ''}
              {smartAccountFlag && !SAPCompany.companyId ? 'Add' : ''}
            </span>
            <span
              tabIndex={0}
              role="button"
              className="share-group-button cancel-button"
              onClick={() => modalToggle()}
              onKeyPress={() => modalToggle()}
            >
              Cancel
            </span>
          </div>
        </Modal>
      )}
    </Wrapper>
  );
};

SelectCompanyModal.defaultProps = defaultProps;
export default SelectCompanyModal;

